import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Divider, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
const DescriptionCardWithLogo = (props) => {
    const { logo, title, description, goal } = props;
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    return (_jsxs(Stack, { flexDirection: { xs: "column", md: "row" }, sx: {
            p: { xs: "28px 24px", md: 8 },
            gap: { xs: 2.5, md: 7 },
            border: "1px solid",
            borderColor: "border.default",
            backgroundColor: "#fff",
            alignItems: "center",
        }, children: [logo && (_jsx(Box, { sx: {
                    width: { xs: "140px", md: "164px" },
                    minHeight: { xs: "44px", md: "53px" },
                    flexShrink: 0,
                }, children: logo })), !isMobile && (_jsx(Divider, { orientation: "vertical", sx: {
                    width: 2,
                    height: "stretch",
                    backgroundColor: "border.default",
                } })), _jsxs(Stack, { sx: { gap: { xs: 2, md: 3 } }, children: [_jsx(Typography, { variant: "h5", component: "h2", color: "text.primary", children: title }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: description }), _jsx(Typography, { variant: "subtitle1", component: "p", color: "text.primary", children: goal })] })] }));
};
export default DescriptionCardWithLogo;
